(function () {
    'use strict';

    function tuneNavigation() {
        var menu = document.querySelector('#gh-head .gh-head-menu');
        var nav = menu && menu.querySelector('.nav');
        if (!nav) return;

        var first = nav.querySelector('li:first-child a');
        if (first && first.textContent.trim() === '百家樂首頁') {
            first.textContent = '首頁';
        }

        var fixedAllLink = menu.querySelector('.qy-nav-all');
        var hasAllLink = Array.prototype.some.call(nav.querySelectorAll('a'), function (link) {
            return link.textContent.trim() === '全部文章';
        });
        if (fixedAllLink && hasAllLink) {
            fixedAllLink.hidden = true;
        }

        if (!menu.querySelector('.qy-mobile-cta')) {
            var mobileCta = document.createElement('a');
            mobileCta.className = 'qy-mobile-cta';
            mobileCta.href = 'https://qywin66.com/?a=970984';
            mobileCta.target = '_blank';
            mobileCta.rel = 'noopener noreferrer';
            mobileCta.textContent = '挑戰百家樂 ↗';
            menu.appendChild(mobileCta);
        }
    }

    function initFooterMascot() {
        var link = document.querySelector('.qy-footer__mascot-link');
        if (!link) return;

        function toggle(state) {
            link.classList.toggle('is-hover', state);
        }

        link.addEventListener('mouseenter', function () { toggle(true); });
        link.addEventListener('mouseleave', function () { toggle(false); });
        link.addEventListener('focus', function () { toggle(true); });
        link.addEventListener('blur', function () { toggle(false); });
        link.addEventListener('touchstart', function () {
            link.classList.add('is-hover');
        }, { passive: true });
    }

    function revealOnScroll() {
        if (!('IntersectionObserver' in window)) return;

        var items = document.querySelectorAll('.qy-category-card, .qy-about-card, .qy-home-card');
        if (!items.length) return;

        items.forEach(function (el) {
            el.classList.add('qy-reveal');
        });

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.12 });

        items.forEach(function (el) { observer.observe(el); });
    }

    document.addEventListener('DOMContentLoaded', function () {
        tuneNavigation();
        revealOnScroll();
        initFooterMascot();
    });
})();
